import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-additional-info',
  templateUrl: './additional-info.component.html',
  styleUrls: ['./additional-info.component.scss']
})
export class AdditionalInfoComponent implements OnInit {
  @Input() items;
  @Input() title;
  @Input() language;
  @Input() locale;
  @Input() dateformat;

  constructor() { }

  ngOnInit() {
    if (this.language === 'French') {
      if (this.title === 'Summary of Account') {
        this.title = 'Récapitulatif du compte';
      } else if (this.title === 'Additional Information') {
        this.title = 'Informations additionnelles';
      } else if (this.title === 'Credit Note') {
        this.title = 'Avoir';
      } else if (this.title === 'Bad Debt Write-Off') {
        this.title = 'Créances Irrécouvrables';
      }
    }
  }

}
